import React from "react";

const ShiftBoard = () => {
    return <div>ShiftBoard</div>;
}

export default ShiftBoard;